import { actionTypes, CreateMembershipPlanInput, MembershipPlansProps } from "./actionType";
import { showSnackbar } from "utils/snack_bar/store/action";
import { FETCH_COMMERCIAL_MEMBERSHIP_PLANS } from "../graphql/query";
import { CREATE_MEMBERSHIP_PLAN, UPDATE_MEMBERSHIP_PLAN } from "../graphql/mutation";
import { executeMutation, executeQuery } from "utils/services/apiServices";

// fetch membership plan
export const fetchMembershipPlanRequest = () => ({
  type: actionTypes.FETCH_MEMBERSHIP_PLANS_REQUEST,
});

export const fetchMembershipPlanSuccess = (
  payload: MembershipPlansProps[]
) => ({
  type: actionTypes.FETCH_MEMBERSHIP_PLANS_SUCCESS,
  payload,
});

export const fetchMembershipPlanFail = (payload: string) => ({
  type: actionTypes.FETCH_MEMBERSHIP_PLANS_FAIL,
  payload,
});

export const fetchMembershipPlan = (limit: number, offset: number) => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchMembershipPlanRequest());
      const response = await executeQuery(FETCH_COMMERCIAL_MEMBERSHIP_PLANS, { limit, offset });
      const jsonData = response.data?.fetchAllMemberships;
      if (jsonData?.error === null) {
        dispatch(
          fetchMembershipPlanSuccess(jsonData?.data)
        );
      } else {
        dispatch(fetchMembershipPlanFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(fetchMembershipPlanFail("Failed to fetch commercial membership(s)"));
    }
  };
};
// fetch membership plan summary
export const fetchMembershipPlanSummaryRequest = () => ({
  type: actionTypes.FETCH_MEMBERSHIP_PLANS_REQUEST,
});

export const fetchMembershipPlanSummarySuccess = (
  payload: MembershipPlansProps[]
) => ({
  type: actionTypes.FETCH_MEMBERSHIP_PLANS_SUCCESS,
  payload,
});

export const fetchMembershipPlanSummaryFail = (payload: string) => ({
  type: actionTypes.FETCH_MEMBERSHIP_PLANS_FAIL,
  payload,
});

export const fetchMembershipPlanSummaryByPackageId = (membership_plan_id: string) => {
  return async (dispatch: any) => {
    try {
      const input = {
        membership_plan_id: membership_plan_id,
      };
      await dispatch(fetchMembershipPlanSummaryRequest());
      const response = await executeQuery(
        FETCH_COMMERCIAL_MEMBERSHIP_PLANS,
        input
      );
      const jsonData = response.data?.fetchMembershipSummary;
      if (jsonData?.error === null) {
        dispatch(
          fetchMembershipPlanSummarySuccess(jsonData?.data)
        );
      } else {
        dispatch(fetchMembershipPlanSummaryFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
      }
    } catch (error: any) {
      dispatch(fetchMembershipPlanSummaryFail("Failed to fetch commercial membership(s)"));
    }
  };
};

// create membership plan
export const createMembershipPlanRequest = () => ({
  type: actionTypes.CREATE_MEMBERSHIP_PLAN_REQUEST,
});

export const createMembershipPlanSuccess = (payload: MembershipPlansProps) => ({
  type: actionTypes.CREATE_MEMBERSHIP_PLAN_SUCCESS,
  payload,
});

export const createMembershipPlanFail = (payload: string) => ({
  type: actionTypes.CREATE_MEMBERSHIP_PLAN_FAIL,
  payload,
});

export const createMembershipPlan = (
  createDataInput: CreateMembershipPlanInput
) => {
  return async (dispatch: any) => {
    try {
      dispatch(createMembershipPlanRequest());
      const response = await executeMutation(CREATE_MEMBERSHIP_PLAN, createDataInput);
      const jsonData = response.data?.createMembershipPlan;
      if (jsonData?.error === null) {
        dispatch(
          createMembershipPlanSuccess(jsonData?.data)
        );
        dispatch(showSnackbar("Success! Package created."));
      } else {
        dispatch(createMembershipPlanFail(jsonData?.error.message));
         dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
        dispatch(showSnackbar("Fail to Create."));
      }
    } catch (error: any) {
      dispatch(
        createMembershipPlanFail("Something went wrong, Try again later")
      );
    }
  };
};

// update membership plan
export const updateMembershipPlanRequest = () => ({
  type: actionTypes.UPDATE_MEMBERSHIP_PLAN_REQUEST,
});

export const updateMembershipPlanSuccess = (payload: MembershipPlansProps) => ({
  type: actionTypes.UPDATE_MEMBERSHIP_PLAN_SUCCESS,
  payload,
});

export const updateMembershipPlanFail = (payload: string) => ({
  type: actionTypes.UPDATE_MEMBERSHIP_PLAN_FAIL,
  payload,
});

export const updateMembershipPlan = (
  updateDataInput: CreateMembershipPlanInput
) => {
  return async (dispatch: any) => {
    try {
      dispatch(updateMembershipPlanRequest());
      const response = await executeMutation(UPDATE_MEMBERSHIP_PLAN, updateDataInput);
      const jsonData = response.data?.updateMembershipPlan;
      if (jsonData?.error === null) {
        dispatch(
          updateMembershipPlanSuccess(jsonData?.data)
        );
        dispatch(showSnackbar("Success! Package created."));
      } else {
        dispatch(updateMembershipPlanFail(jsonData?.error.message));
         dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
        dispatch(showSnackbar("Fail to Create."));
      }
    } catch (error: any) {
      dispatch(
        updateMembershipPlanFail("Something went wrong, Try again later")
      );
    }
  };
};

